import React from 'react'
import useGlobalSettings from '../../hooks/useGlobalSettings';
import { Link } from 'react-router-dom';

const WhatsApp = () => {
    const { globalData } = useGlobalSettings();
    const whatsapp_number = globalData?.whatsapp
    return (
        <Link
            to={`https://api.whatsapp.com/send?phone=${whatsapp_number}`}
            className="whatsapp-btn"
            target="_blank"
            rel="noreferrer"
        >
            <i className='bx bxl-whatsapp'></i>{ }
        </Link>
    )
}

export default WhatsApp
